<template>
  <v-flex
    xs12
  >
    <v-layout
      row
      wrap
    >
      <v-flex
        xs12
        md4
        offset-md1
      >
        <v-flex :class="disabled ? 'text--disabled' : ''">
          <h3 class="title font-weight-regular pt-3">
            {{ $t('Tax Rates') }}
          </h3>
          <span class="caption">
            {{ $t('Customize your tax rate names and % rate.') }}
          </span>
        </v-flex>
        <v-flex
        >
          <v-btn
            :disabled="disabled"
            class="mx-0"
            @click="addNewTaxRate(true)"
          >
            {{ $t('Add tax rates') }}
          </v-btn>
        </v-flex>
      </v-flex>
      <v-flex
        xs12
        md6
      >
        <v-card
          flat
          class="pa-3"
        >
          <LoadingStateMicro
            v-if="!taxes"
            :loading="true"
          />
          <template v-else>
            <div v-if="taxes.length">
              <v-list
                v-for="(tax, index) in taxes"
                :key="tax.id"
                two-line
                subheader
              >
                <v-list-tile
                  :disabled="disabled"
                  @click="selectTax(tax.id)"
                >
                  <v-list-tile-content>
                    <v-list-tile-title>{{ tax.name }}</v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{ tax.code }}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>

                  <v-list-tile-action>
                    <span color="primary--text">{{ $t('Rate:') }} {{ tax.rate }}</span>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider
                  v-if="index < taxes.length-1"
                />
              </v-list>
            </div>
            <v-list-tile v-else>
              {{ $t('No tax rates to display') }}
            </v-list-tile>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
    <template
      v-if="dialog"
    >
      <v-dialog
        v-model="dialog"
        persistent
        max-width="600px"
      >
        <v-card>
          <div v-if="(taxRates && taxRates.length) || selectedTaxRate">
            <SettingsTaxRateWidget
              :selected-tax="selectedTaxRate"
              :new-tax-rates="taxRates"
              @addNewTaxRate="addNewTaxRate"
              @removeNewTaxRate="removeNewTaxRate"
            />
          </div>
          <template v-else>
            <v-card-title />
            <loading-state-micro
              :loading="true"
            />
          </template>
          <v-card-actions>
            <v-btn
              v-if="selectedTaxRate && selectedTaxRate.id"
              color="darken-1"
              flat
              small
              @click="removeTaxRate"
            >
              {{ $t('Delete') }}
            </v-btn>

            <v-spacer />
            <v-btn
              color="darken-1"
              flat
              small
              @click="dialog = false"
            >
              {{ $t('Close') }}
            </v-btn>
            <v-btn
              color="primary darken-1"
              flat
              small
              @click="saveTaxRateSeries"
            >
              {{ $t('Save') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </template>
  </v-flex>
</template>

<script>
import TaxMixin from './TaxesMixin'
import SettingsTaxRateWidget from '@/modules/Settings/components/Taxes/SettingsTaxRateWidget'
import uuid4 from 'uuid'

export default {
  name: 'TaxRateList',

  components: {
    SettingsTaxRateWidget
  },

  mixins: [ TaxMixin ],

  props: {
    taxes: {
      type: Array,
      default: () => {}
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      selectedTaxRate: null,
      dialog: false,
      taxRates: [],
      schema: {
        'name': '',
        'rate': '0.0'
      }
    }
  },

  methods: {
    addNewTaxRate (isNew) {
      if (isNew) {
        this.selectedTaxRate = null
        this.taxRates = []
        this.dialog = true
      }
      let copySchema = { ...this.schema }
      copySchema.uuid = uuid4()
      this.taxRates.push(this.$http.make('taxRates', copySchema))
    },

    removeNewTaxRate (uuid) {
      this.taxRates = this.taxRates.filter(taxRate => taxRate.uuid !== uuid)
    },

    async selectTax (taxId) {
      this.selectedTaxRate = null
      this.taxRates = []
      let tax = null
      this.dialog = true
      tax = await this.$http.make('taxRates').find(taxId)

      let copySchema = { ...this.schema }
      copySchema.id = taxId
      this.rebindValues(tax, copySchema, Object.keys(this.schema))
      this.selectedTaxRate = await this.$http.make('taxRates', copySchema)
    },

    async saveTaxRateSeries () {
      let results
      if (this.taxRates && this.taxRates.length) {
        results = await Promise.all(this.taxRates.map(async tax => {
          return this.saveTaxRate(tax)
        }))
        results = results.every(result => result)
        if (!results) {
          this.taxRates = this.taxRates.filter(tax => tax.errors.length)
          return
        }
      } else {
        results = await this.saveTaxRate(this.selectedTaxRate)
      }
      if (results) {
        this.closeDialogMixin(this.$t('Tax rates updated'))
      }
    },

    async saveTaxRate (tax) {
      this.cleanFields(tax)
      let copySchema = { ...this.schema }
      if (tax.id) {
        copySchema.id = tax.id
      }
      this.rebindValues(tax, copySchema, Object.keys(this.schema))
      let taxCopy = await this.$http.make('taxRates', { ...copySchema })
      try {
        await taxCopy.save()
        tax = null
        taxCopy = null
        return true
      } catch (e) {
        tax.errors = [...taxCopy.errors]
        this.$toast.error(this.$t(e.message))
        return false
      }
    },

    async removeTaxRate () {
      await this.selectedTaxRate
        .delete()
        .then(() => {
          this.closeDialogMixin(this.$t('Tax rates updated'))
        })
    }
  }
}
</script>
